<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('contact_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-account-cash</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-contact-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('contact.firstname') }}</strong></td>
              <td>
                                    {{ item['firstname'] }}
              </td>
              <td><strong>{{ $t('contact.lastname') }}</strong></td>
              <td>
                                    {{ item['lastname'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('contact.customer') }}</strong></td>
              <td>
                  <span  v-if="item['customer']"><router-link class="routerLink text-decoration-underline" :to="{ name: 'CustomerShow', params: { id:  item['customer']['@id']}  }">{{ item['customer'].name }}</router-link></span>
              </td>
              <td><strong>{{ $t('contact.comptehub') }}</strong></td>
              <td>
                <span v-if="item.comptehub" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('contact.email') }}</strong></td>
              <td>
                  <a v-if="item['email']" :href=" 'mailto:' + item['email']" >{{ item['email'] }}</a>
              </td>
              <td><strong>{{ $t('contact.phone') }}</strong></td>
              <td>
                  <a v-if="item['phone']" href=" 'tel:' + item['phone']" >{{ item['phone'] }}</a>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('contact.locale') }}</strong></td>
              <td>
                  {{ item['locale'] }}
              </td>
              <td></td>
              <td>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';


const servicePrefix = 'Contact';

export default {
  name: 'ContactShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
  },
  data() {
    return {

    };
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('contact', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('contact', ['find']),

  },
  methods: {
    ...mapActions('contact', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  }
};
</script>
